import { RATING_AGE } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";

export default function AgeRestriction({ watch }) {
  const { episode } = watch;
  const age = RATING_AGE[episode.rating];
  return (
    <div className={styles.age}>
      <p className={styles.message}>{age}歳以上の方がご視聴いただけます。</p>
    </div>
  );
}
